import type {VideoDraftInput} from '../../protocol/video-draft';
type Stage=(draft:VideoDraftInput)=>Promise<void>;
let stage:Stage|null=null;
type SourcePicker=(kind:'upload'|'library')=>Promise<void>;
let picker:SourcePicker|null=null;
export function connectVideoSourcePicker(next:SourcePicker){picker=next;return()=>{if(picker===next)picker=null;};}
export async function requestVideoSource(kind:'upload'|'library'){
  const current=picker;if(!current)throw new Error('현재 와카 작업에 연결한 뒤 다시 시도해 주세요.');
  await current(kind);
  if(current!==picker)throw new Error('작업 연결이 바뀌었습니다. 현재 작업에서 다시 선택해 주세요.');
}
/** Save first; the authenticated host opens an editable confirmation, never automatic generation. */
export function connectVideoDraftStage(next:Stage){stage=next;return()=>{if(stage===next)stage=null;};}
export async function stageVideoDraft(draft:VideoDraftInput){
  const current=stage;if(!current)throw new Error('현재 와카 작업에 연결한 뒤 다시 시도해 주세요.');
  await current(draft);
  if(current!==stage)throw new Error('작업 연결이 바뀌었습니다. 현재 작업에서 다시 확인해 주세요.');
}
